if (typeof BSS_B2B != undefined) {
  if (window.location.pathname.includes("/products")) {
    setTimeout(() =>{
      const targetVariant = document.querySelector(`[id*="product-form-installment-template"] input[name="id"]`);
      if (targetVariant) {
        const mutationObserver = new MutationObserver((recordList, observe) => {
          setTimeout(() =>{
            const productForm = document.querySelector("[bss-b2b-main-product-form]");
            BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
          }, 1000)
          
        });
        mutationObserver.observe(targetVariant, { attributes: true });
      }
    }, 4000)
  }
}